/**
 * Como a moeda estrangeira se escreve na tela. Espelha
 * `backend/src/services/moeda/carteira.ts`: mesmos símbolos, mesmos nomes.
 */
const NOMES: Record<string, { simbolo: string; nome: string }> = {
  EUR: { simbolo: '€', nome: 'euro' },
  USD: { simbolo: 'US$', nome: 'dólar' },
  GBP: { simbolo: '£', nome: 'libra' },
  ARS: { simbolo: 'ARS', nome: 'peso argentino' },
  CLP: { simbolo: 'CLP', nome: 'peso chileno' },
  UYU: { simbolo: 'UYU', nome: 'peso uruguaio' },
  CAD: { simbolo: 'C$', nome: 'dólar canadense' },
  JPY: { simbolo: '¥', nome: 'iene' },
  CHF: { simbolo: 'CHF', nome: 'franco suíço' },
};

export const MOEDAS = Object.keys(NOMES);

export const nomeDaMoeda = (moeda: string): string => NOMES[moeda]?.nome ?? moeda;

/** "€ 20", "US$ 1.250,50". */
export const naMoeda = (valor: number, moeda: string): string => {
  const inteiro = Math.abs(valor - Math.round(valor)) < 0.005;
  const n = valor.toLocaleString('pt-BR', { minimumFractionDigits: inteiro ? 0 : 2, maximumFractionDigits: 2 });
  return `${NOMES[moeda]?.simbolo ?? moeda} ${n}`;
};

/** "1.234,56" ou "1234.56" → número. `null` quando não é quantia positiva. */
export const lerQuantia = (texto: string): number | null => {
  const t = texto.trim().replace(/\s/g, '');
  if (!t) return null;
  const n = Number(t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t);
  return Number.isFinite(n) && n > 0 ? Math.round(n * 100) / 100 : null;
};
